import axios from "axios";

export function getFinances() {
  return axios.get(`${process.env.REACT_APP_SISAPI}/v1/acropolis/pagos`);
  // return axios.get(`https://sisapi.aden.org/api/v1/acropolis/pagos`);
}
